import React, { useEffect, useState } from "react";
import ReleaseNotes from "../../components/release-notes/ReleaseNotes";
import { AboutUsPageData } from "../../components/release-notes/AboutUsPageData";
// import { FeatureRoadmap } from "@me8eon/feature_roadmap";

import {
    EonUiAccordion,
    EonUiAccordionPane,
    EonUiTab,
    EonUiTabs,
} from "@eon-ui/eon-ui-components-react";
import { useTranslation } from "@me8eon/translation";
import {
    aboutUsHeading,
    aboutUsSubHeading,
    faqText,
    headerTextData,
    tipsAndTricksText,
    whatsNewText,
} from "../../components/release-notes/AboutUsPageData";
// @ts-ignore
import About_me from "../../assets/image/about-me.jpg";
import "./AboutUs.scss";
import { useNavigate, useSearchParams } from "react-router-dom";

const HeaderSection: React.FC<{ language: string }> = ({ language }) => (
    <>
        <div className="about-us-header-section">
            <div style={{
                position: "relative",
                overflow: "hidden",
                aspectRatio: "1920 / 1080",
            }} className="column about-us-image">
                <iframe src="https://player.vimeo.com/video/1191536448?badge=0&autopause=0&player_id=0&app_id=58479"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0, width: "100%", height: "100%"
                    }}
                    title="MyHelp">
                </iframe>
            </div>
            <div className="column about-us-header-label">
                {aboutUsHeading[language].map((text, index) => (
                    <div className="looking-label" key={index} dangerouslySetInnerHTML={{ __html: text }}></div>
                ))}
                {aboutUsSubHeading[language].map((text, index) => (
                    <div className="find-out-label" key={index}>
                        {text}
                    </div>
                ))}
            </div>
        </div>
        <div
            className="about-us-hint-section"
        >
            {headerTextData[language].map((text, index) => (
                <div
                    key={index}
                    dangerouslySetInnerHTML={{ __html: text.trim() }}
                ></div>
            ))}
        </div>
    </>
);

const FaqSection: React.FC<{ language: string }> = ({ language }) => (
    <EonUiAccordion mode="single" key={language} data-testid="releaseNotes">
        {faqText[language].map((notes, index) => (
            <EonUiAccordionPane
                pane-title={notes.question}
                slot={notes.question}
                key={`${index}`}
            >
                <div key={index} dangerouslySetInnerHTML={{ __html: notes.answer.trim() }}></div>
            </EonUiAccordionPane>
        ))}
    </EonUiAccordion>
);

const TipsAndTricksSection: React.FC<{ language: string }> = ({ language }) => (
    <>
        {tipsAndTricksText[language].map((tip, index) => (
            <div key={index} dangerouslySetInnerHTML={{ __html: tip }} />
        ))}
    </>
);

const WhatsNewSection: React.FC<{ language: string }> = ({ language }) => (
    <ul>
        {AboutUsPageData[AboutUsPageData.length - 1]?.content[language].map((item, index) => (
            <li key={index}>
                <span dangerouslySetInnerHTML={{ __html: item }}></span>
            </li>
        ))}
    </ul>
);

const AboutUs: React.FC = () => {
    const { t, i18n } = useTranslation("about-us");
    const [searchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        const tabParam = searchParams.get('tab');
        if (tabParam) {
            setActiveTab(Number(tabParam));
        }
    }, [searchParams]);

    return (
        <div className="about-us-container">
            <HeaderSection language={i18n.language} />
            <EonUiTabs
                active-tab-index={activeTab}
                onTabChanged={(obj) => navigate(`/about-myhelp?tab=${obj.detail}`)}
                description="Short description of the tabs"
                inner-background="eon-lightgrey"
                key={i18n.language}
            >
                <EonUiTab header={t("releaseNotes.faq")} tab-id="faq">
                    <FaqSection language={i18n.language} />
                </EonUiTab>
                <EonUiTab
                    header={t("releaseNotes.tipsAndTricks")}
                    tab-id="tipsAndTricks"
                >
                    <TipsAndTricksSection language={i18n.language} />
                </EonUiTab>
                <EonUiTab header={t("releaseNotes.whatsNew")} tab-id="whatsNew">
                    <WhatsNewSection language={i18n.language} />
                </EonUiTab>
                <EonUiTab
                    header={t("releaseNotes.tabName")}
                    tab-id="releaseNotes"
                >
                    <div className="release-history" data-testid="aboutUs">
                        <ReleaseNotes />
                    </div>
                </EonUiTab>
                {/* <EonUiTab
                    header={t("featureRoadmap.tabName")}
                    tab-id="featureRoadmap">
                    <FeatureRoadmap />
                </EonUiTab> */}
            </EonUiTabs>
        </div>
    );
};

export default AboutUs;
